import BillingAccounts from "pages/BillingAccounts";

export default function AdminBillingAccounts({ currentUser }) {
  return <BillingAccounts currentUser={currentUser} role="admin" />;
}
